export const certificateConstants = {
  LOAD_REQUEST: 'CERTIFICATE_LOAD_REQUEST',
  LOAD_SUCCESS: 'CERTIFICATE_LOAD_SUCCESS',
  LOAD_FAILURE: 'CERTIFICATE_LOAD_FAILURE',

  CERT_REQUEST: 'CERTIFICATION_REQUEST',
  CERT_SUCCESS: 'CERTIFICATION_SUCCESS',
  CERT_FAILURE: 'CERTIFICATION_FAILURE',
  CERT_SET_INITIAL_STATE: 'CERTIFICATION_SET_INITIAL_STATE',

  CERT_RESULT_REQUEST: 'CERTIFICATION_RESULT_REQUEST',
  CERT_RESULT_SUCCESS: 'CERTIFICATION_RESULT_SUCCESS',
  CERT_RESULT_FAILURE: 'CERTIFICATION_RESULT_FAILURE',

  CERT_POP_REQUEST: 'CERTIFICATION_POP_UP_REQUEST',
  CERT_POP_SUCCESS: 'CERTIFICATION_POP_UP_SUCCESS',
  CERT_POP_FAILURE: 'CERTIFICATION_POP_UP_FAILURE',

  CERT_IPIN_POP_REQUEST: 'CERTIFICATION_IPIN_POP_UP_REQUEST',
  CERT_IPIN_POP_SUCCESS: 'CERTIFICATION_IPIN_POP_UP_SUCCESS',
  CERT_IPIN_POP_FAILURE: 'CERTIFICATION_IPIN_POP_UP_FAILURE',

  CERT_TEMP: 'CERTIFICATION_TEMP',
}
